const DEFAULT_DATA = Object.assign({}, { items: [], loading: true, loaded: false });

const getFlags = (state, id) => state.document.stateTransitions[id];
const getState = (state, key) => state.entities.stateTransitions[key];

export const getStateTransitions = (state, key) => {
  const flags = getFlags(state, key);
  if (!flags?.loaded || flags?.loading) return DEFAULT_DATA;

  return Object.assign({}, { ...getState(state, key), ...flags });
};
